// extracted by mini-css-extract-plugin
module.exports = {"text-align-center":"e2ff468f85--text-align-center--wS6Cz","text-align-right":"e2ff468f85--text-align-right--EMFbI"};